import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class CustomerEnquiryService {
  constructor(private http: HttpUtilService) {}

  /**
   * Searches for customer information based on the provided search option and search text.
   * Calls the API: CustomerEnquiryService.asmx/Search
   * @param searchOption The option used for searching (e.g., 1 for name-based search).
   * @param searchText The text to search for, encoded as required by the API.
   * @returns Observable containing the search results.
   */
  searchCustomer(searchOption: number, searchText: string): Observable<any> {
    const encodedSearchText = encodeURIComponent(`"${searchText}"`);
    const url = `CustomerEnquiryService.asmx/Search?searchOption=${searchOption}&searchText=${encodedSearchText}`;
    
    return this.http.get(url);
  }
}
